var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "panel-body card p-1" }, [
      _c("table", { staticClass: "table table-striped" }, [
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm._l(_vm.available_email_marketings, function (email_marketing) {
              return _c("tr", [
                _c("th", { attrs: { scope: "row" } }, [
                  _vm._v(_vm._s(email_marketing.name)),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(email_marketing.enabled ? "Yes" : "No")),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(email_marketing.send_at))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(email_marketing.filter.name))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      !email_marketing.last_executed
                        ? "Never"
                        : email_marketing.last_executed
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/admin/email-marketing-edit/" + email_marketing.id,
                      },
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn-sm btn-outline-warning",
                          attrs: { type: "button" },
                        },
                        [_vm._v("EDIT")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn-sm btn-outline-danger",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.deleteMarketingEmail(email_marketing.id)
                        },
                      },
                    },
                    [_vm._v("DELETE")]
                  ),
                ]),
              ])
            }),
            _vm._v(" "),
            !_vm.available_email_marketings ||
            _vm.available_email_marketings.length === 0
              ? _c("tr", [
                  _c("th", [_vm._v("-- No Marketing Emails --")]),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("td"),
                  _vm._v(" "),
                  _c("td"),
                ])
              : _vm._e(),
          ],
          2
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("h4", [_vm._v("Scheduled Marketing Emails")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "When you want to send a unique email to a group of users once."
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "w-100 mb-1" }, [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("div", { staticClass: "ml-auto mb-05" }, [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-success ml-05",
                    attrs: { href: "/admin/email-marketing-create" },
                  },
                  [
                    _c("i", { staticClass: "feather icon-plus" }),
                    _vm._v("Create Marketing Email"),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Name")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Enabled")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Send At")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Filter")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [_vm._v("Last Sent")]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }